<script lang="ts">
  import { getStr } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import PdpVasReadonlyRow from './PDPVasReadonlyRow.svelte';

  export let data: any;

  $: hasValidData = data?.length > 0;
  $: additionalServices = hasValidData && populateAdditionalServices(data);

  function populateAdditionalServices(data) {
    const additionalServices =
      data?.map(lmdConfig =>
        Object.assign(
          {},
          {
            vasType: { label: lmdConfig?.description },
            servicePrice: lmdConfig?.price,
          }
        )
      ) || [];

    return additionalServices;
  }
</script>

{#if hasValidData}
  <section class="additional-services-mini-card">
    <section class="title">
      <Icon type="font" glyph="settings" mobileSize={20} desktopSize={20} />
      <h3>{getStr('extra.pdp.additional.service')}</h3>
    </section>
    <section class="additional-service-list">
      {#each additionalServices as vasPrice}
        <PdpVasReadonlyRow data={vasPrice} />
      {/each}
    </section>
  </section>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .additional-services-mini-card {
    margin-top: 24px;

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      color: $icon-only-icon-blue;

      h3 {
        margin: 0;
        font-size: 18px;
        line-height: 20px;
        font-weight: 700;
        color: $neutral-dark-01;
      }
    }
    .additional-service-list {
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  }
</style>
